const data = {
  ru: {
    header_sele: "Выберите модель телефона",
    hero: "Аксессуары для Iphone 13 Pro Max",
    main_chexol: "Чехлы",
    main_naushnik: "Наушники",
    main_naushnik1: "Наушники и прочее",
    sum: "Сумма",
    singlcard_tit: "Описание и характеристики",
    singlcard_desc: "Активное шумоподавление: Нет",
    singlcard_desc1: "Вес: 10 гр",
    singlcard_desc2: "Влагозащита: Нет",
    singlcard_btn: "Купить!",
    singlcard_btn1: "Добавить в корзину",

    order_tit: "Доставка курьером",
    order_tit1: "Адрес доставки",
    order_opt: "Город",
    order_opt1: "Улица / Район",
    order_opt2: "Дом",
    order_opt3: "Подъезд",
    order_opt4: "Квартира",
    order_zak: "Ваш заказ",
    order_zak1: "Доставка",
    order_zak2: "К оплате",
    order_zak3: "СпоПерейти к оформлениюсоб оплаты",
    order_zak4: "Оплата через банк",
    order_zak5: "Оплата наличными",
    order_zak6: "Есть промокод?",
    order_zak7: "Номер получателя",
    order_zak8: "Закончить оформление",
    order_P: "Номер вашего заказа №123123, с Вами свяжется наш менеджер.",

    karz: "Корзина",
    karz1: "Доставка",
    karz2: "Доставка курьером",
    karz3: "ИТОГО",
    karz4: "Перейти к оформлению",
    karzP: "Корзина пуста",
    karzP1: "Но это никогда не поздно исправить",
    karzP2: "В каталог товаров",

    cont: "Наш офис",
    cont1: "Катортол, Чиланзор, Тошкентское ш., Узбекистан",
    cont2: "3 этаж 35 кабинет",

    ser: "Условия сервиса",
    ser1: "Задача организации, в особенности же курс на социально-ориентированный национальный проект требует от нас системного анализа модели развития! Таким образом, постоянное информационно-техническое обеспечение нашей деятельности требует от нас анализа системы масштабного изменения ряда параметров! С другой стороны социально-экономическое развитие напрямую зависит от всесторонне сбалансированных нововведений?",
    langBtnUz: "language uz",
    langBtnRu: "activs",
    langBtnEng: "",

    footer_select: "Избранное",
    footer_kar: "Корзина",
    footer_kon: "Контакты",
    footer_usluga: "Условия сервиса",
  },

  uz: {
    header_sele: "Telefon modelini tanlang",
    hero: "Iphone 13 Pro Max uchun aksessuarlar",
    main_chexol: "Chexollar",
    main_naushnik: "Naushniklar",
    main_naushnik1: "Naushnik va boshqalar",
    sum: "Sum",

    singlcard_tit: "Tavsif va xususiyatlar",
    singlcard_desc: "Faol shovqinni bekor qilish: Yo'q",
    singlcard_desc1: "Og'irligi: 10 gr",
    singlcard_desc2: "Suv o'tkazmaydigan: Yo'q",
    singlcard_btn: "Sotib olish!",
    singlcard_btn1: "Savatga qo'shish",

    order_tit: "Kuryer yetkazib berish",
    order_tit1: "Yetkazib berish manzili",
    order_opt: "Shahar",
    order_opt1: "Ko'cha / Tuman",
    order_opt2: "Uy",
    order_opt3: "Podez",
    order_opt4: "Kvartira",
    order_zak: "Sizning buyurtmangiz",
    order_zak1: "Yetkazib berish",
    order_zak2: "To'lash uchun",
    order_zak3: "To'lov usuli",
    order_zak4: "Bank to'lovi",
    order_zak5: "Naqd to'lov",
    order_zak6: "Promo-kod bormi?",
    order_zak7: "Qabul qiluvchining raqami",
    order_zak8: "Zakazni yakunlash",
    order_P:
      "Sizning buyurtma raqamingiz 123123, menejerimiz siz bilan bog'lanadi.",

    karz: "Korzina",
    karz1: "Dostavka",
    karz2: "Kuryer yetkazib berish",
    karz3: "JAMI",
    karz4: "Rasmiylashtirishga o'tish",
    karzP: "Korzina bo'sh",
    karzP1: "Ammo tuzatish uchun hech qachon kech emas",
    karzP2: "Mahsulotlar katalogiga qaytish",

    cont: "Bizning ofisimiz",
    cont1: "Qatortol, Chilonzor, Toshkent sh., O'zbekiston",
    cont2: "3-qavat 35 xona",

    ser: "Xizmat ko'rsatish shartlari",
    ser1: "Tashkilotning vazifasi, xususan, yo'nalish ijtimoiy yo'naltirilgan milliy loyiha bizdan talab qiladi rivojlanish modelining tizimli tahlili! Shunday qilib, doimiy faoliyatimizni axborot va texnik qo'llab-quvvatlashni talab qiladi bir qator parametrlardagi keng ko'lamli o'zgarishlar tizimini tahlil qilish! Boshqa bilan tomoni, ijtimoiy-iqtisodiy taraqqiyot bevosita bog'liq har tomonlama muvozanatli innovatsiyalar?",
    langBtnUz: "language activs uz",
    langBtnRu: "",
    langBtnEng: "",

    footer_select: "Sevimlilar",
    footer_kar: "Karzinaka",
    footer_kon: "Kontaktlar",
    footer_usluga: "Xizmat ko'rsatish shartlari",
  },

  eng: {
    header_sele: "Select phone model",
    hero: "Accessories for Iphone 13 Pro Max",
    main_chexol: "Cases",
    main_naushnik: "Headphones",
    main_naushnik1: "Headphones and others",
    sum: "Sum",
    singlcard_tit: "Description and characteristics",
    singlcard_desc: "Active Noise Cancellation: No",
    singlcard_desc1: "Weight: 10 gr",
    singlcard_desc2: "Waterproof: No",
    singlcard_btn: "Buy!",
    singlcard_btn1: "Add to Shopping Cart",

    order_tit: "Courier delivery",
    order_tit1: "Delivery address",
    order_opt: "City",
    order_opt1: "Street / District",
    order_opt2: "House",
    order_opt3: "Entrance",
    order_opt4: "Flat",
    order_zak: "Your order",
    order_zak1: "Delivery",
    order_zak2: "To pay",
    order_zak3: "Payment method",
    order_zak4: "Bank payment",
    order_zak5: "Cash payment",
    order_zak6: "Have a promo code?",
    order_zak7: "Recipient number",
    order_zak8: "complete registration",
    order_P: "Your order number is No. 123123, our manager will contact you.",

    karz: "Basket",
    karz1: "Delivery",
    karz2: "Courier delivery",
    karz3: "TOTAL",
    karz4: "Go to registration",
    karzP: " Basket is empty",
    karzP1: "But it's never too late to fix",
    karzP2: "To product catalog",

    cont: "Our office",
    cont1: "Katortol, Chilonzor, Toshkent city, Uzbekistan",
    cont2: "3 floor 35 room",

    ser: "Terms of service",
    ser1: "The task of the organization, in particular the course towards socially oriented national project requires us to system analysis of the development model! Thus, permanent information and technical support of our activities requires us analysis of the system of large-scale changes in a number of parameters! With another side, socio-economic development directly depends on comprehensively balanced innovations?",
    langBtnUz: "language uz",
    langBtnRu: "",
    langBtnEng: "activs",

    footer_select: "Favorites",
    footer_kar: "Basket",
    footer_kon: "Contacts",
    footer_usluga: "Terms of service",
  },
};

export default data;
